import React from "react";

function wiredConnection() {
    return (
       <svg width="26" height="6" viewBox="0 0 26 6" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M-0.00016284 2.6665C-0.00016284 4.13926 1.19374 5.33317 2.6665 5.33317C4.13926 5.33317 5.33317 4.13926 5.33317 2.6665C5.33317 1.19374 4.13926 -0.00016284 2.6665 -0.00016284C1.19374 -0.00016284 -0.00016284 1.19374 -0.00016284 2.6665ZM19.9998 2.6665C19.9998 4.13926 21.1937 5.33317 22.6665 5.33317C24.1393 5.33317 25.3332 4.13926 25.3332 2.6665C25.3332 1.19374 24.1393 -0.00016284 22.6665 -0.00016284C21.1937 -0.00016284 19.9998 1.19374 19.9998 2.6665ZM2.6665 2.6665V3.1665H22.6665V2.6665V2.1665H2.6665V2.6665Z" fill="#F37320"/>
    </svg>

    );
}

export default wiredConnection;
